export default __webpack_public_path__ + "static/media/Linkedin 3d logo.3f5d3dcc.svg";